import UnassociatedUnits from "../components/UnassociatedUnits";


export default function ManageUnits() {
  return (
      <>
        <UnassociatedUnits />
      </>
  );
}